import { Icon } from "@/components/icons/Icon";
import { literals } from "@/constants/literals";

interface PeititonMessageProps {
  petitionBy: string;
  petition: string;
}

const PetitionMessage = ({ petitionBy, petition }: PeititonMessageProps) => {
  return (
    <div className="text-sm border border-ib-pt-color-red-500 rounded-md p-2 flex flex-row items-center justify-start gap-x-2">
      <span className="text-ib-pt-color-red-500">
        <Icon name={petition === "deletion" ? "remove" : "pencil"} />
      </span>
      <div>
        <p className="text-ib-pt-color-red-500">
          {literals.requestedBy}
          {petitionBy}
        </p>
        {petition === "deletion" ? (
          <p className="font-ib-normal">
            <span>{literals.deletionPetition}</span>
          </p>
        ) : (
          <p className="font-ib-normal">
            <span>
              {literals.edition}
              {petition}
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default PetitionMessage;
